import { Pipe, PipeTransform } from '@angular/core';
import { formatDistanceToNow, differenceInHours, format } from 'date-fns';
import { es } from 'date-fns/locale';
@Pipe({
  name: 'relativeDate',
  standalone: false
})
export class RelativeDatePipe implements PipeTransform {

  transform(value: Date | string | number): string {
    const date = new Date(value);
    const now = new Date();

    // Calcula la diferencia en horas entre la fecha y ahora.
    const diffHours = differenceInHours(now, date);

    // Por ejemplo, si la fecha es de hoy o "ayer" (menos de 24 horas), mostrar el tiempo relativo.
    if (diffHours < 24) {
      return formatDistanceToNow(date, { addSuffix: true, locale: es });
    } else {
      // Si es anterior a 24 horas (o el umbral que definas), formatea la fecha de forma fija.
      // Por ejemplo, 'd MMM' dará algo como "19 ene" y lo convertimos a mayúsculas.
      return format(date, 'd MMM', { locale: es }).toUpperCase();
    }
  }

}
